import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

const tourSteps = [
  {
    target: ".dynamic-table-header",
    content: "Manage the registries used for collateral asset registration.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find registries by name or code.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Registry.",
    placement: "right",
  },
];

const RegistryTable = () => {
  const [runTour, setRunTour] = useState(false);

  const handleToggle = async (row, field, currentValue, label, refetch) => {
    const confirm = await Swal.fire({
      title: `${currentValue ? "Deactivate" : "Activate"} ${label}?`,
      text: `Are you sure you want to ${currentValue ? "disable" : "enable"} "${label}" for this registry?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateRegistry",
      {
        id: row.Id,
        code: row.Code,
        name: row.Name,
        companyId: row.CompanyId,
        [field]: !currentValue,
      },
      "registry",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `${label} has been ${!currentValue ? "enabled" : "disabled"}.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update the registry. Please try again.", "error");
    }
  };

  const actions = {
    entity: localStorage.getItem("SelectedTabLabel") || "Registry",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleActive: {
      key: "TOGGLE_ACTIVE",
      button_name: (row) => (row?.IsActive ? "Deactivate" : "Activate"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggle(row, "isActive", row?.IsActive, "Active Status", refetch),
    },
    toggleHasApi: {
      key: "TOGGLE_HAS_API",
      button_name: (row) => (row?.HasApi ? "Disable API" : "Enable API"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggle(row, "hasApi", row?.HasApi, "Has API", refetch),
    },
    dataObject: {
      ignoreFields: ["CreatedAt", "CreatedBy", "UpdatedAt", "UpdatedBy", "CompanyId"],
      objectName: "allRegistries",
      parameters: "",
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0
    }
  };

  return (
    <Box m="20px">
      <Joyride
        steps={tourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <DynamicTableForJson
        title="Registry Management"
        subtitle="Manage Registries for Collateral Asset Setup"
        FormComponent={Form}
        actions={actions}
        base_url={base_url}
        tourSteps={tourSteps}
      />
    </Box>
  );
};

export default RegistryTable;
